import * as types from './actionTypes';

export const getEmployeeExemptions = (unit_id) => ({
  type: types.GET_EMPLOYEE_EXEMPTIONS,
  payload:{unit_id},
});

export const saveEmployeeExemption = (payload) => ({
  type: types.SAVE_EMPLOYEE_EXEMPTION,
  payload,
});

export const changeEmployeeExemptionStatus = (payload) => ({
  type: types.CHANGE_EMPLOYEE_EXEMPTION_STATUS,
  payload,
});
